export const ResponseCode = {
  Reject: 0,
  Success: 1,
  Customer_Existed: 2,
  Invalid_Email_Token: 3,
  Payment_Failed: 10,
  Payment_Record_Failed: 11
};
